import React from 'react';
import Select from "react-select";
import './style.scss';

const PaginationForTableComponent = (props) => {

  console.log("top Navigation", props.topNavigation);
    const { 
        showNavigation, 
        screenMobile, 
        pageSize, 
        pageIndex, 
        canNextPage, 
        tableData, 
        setPageSize, 
        canPreviousPage, 
        previousPage,
        gotoPage,
        pageCount,
        nextPage
    } = props;

    if(!showNavigation) {
      return <></>;
    }
    
    return (
        <div
        className="shared-filter_list"
        style={{
          display: screenMobile ? "block" : "flex",
          justifyContent: "space-between",
          alignItems: "center",
          backgroundColor: '#fff'
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "6px 0",
          }}
        >
          <p>
            {pageSize * pageIndex + 1}-
            {canNextPage ? pageSize * (pageIndex + 1) : tableData?.length} of{" "}
            {tableData?.length}
          </p>
          <span style={{ margin: "0 8px" }}>|</span>
          <p>Showing</p>
          <Select
            isSearchable={false}
            value={[pageSize].map((val) => ({ label: val, value: val }))}
            options={[
              { label: "10", value: 10 },
              { label: "50", value: 50 },
              { label: "100", value: 100 },
            ]}
            classNamePrefix="select-filter"
            onChange={(selected) => {
              setPageSize(selected.value);
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
            components={{
              DropdownIndicator: () => null,
              IndicatorSeparator: () => null,
            }}
          />
        </div>
        <div className="list-number-pagination">
          <div className="pagination-label">
            <div
              className="list-pagination"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                margin: "6px 0",
              }}
            >
              <i
                className={`ti-control-backward ${
                  !canPreviousPage ? "btn-control-disabled" : ""
                }`}
                onClick={() => previousPage()}
              />
              <button 
                type='button'
                onClick={() => gotoPage(0)}
              >
                First
              </button>
              {((pageIndex + 1) == pageCount) && ((pageIndex + 1) > 1) && (<span>...</span>)}
              <button 
                className="active"
                type="button"
                onClick={() => gotoPage(pageIndex)}
              >
                {pageIndex + 1}
              </button>
                { pageIndex + 2 <= pageCount && (<button 
                  type="button"
                  onClick={() => gotoPage(pageIndex + 1)}
                >
                  {pageIndex + 2}
                </button>)}
                { pageIndex + 3 <= pageCount ? (<button 
                  type="button"
                  onClick={() => gotoPage(pageIndex + 2)}
                >
                  {pageIndex + 3}
                </button>) : ""}
              { (pageIndex + 3 <= pageCount) && (pageIndex + 1 != pageCount) && (<span>...</span>)}
              <button 
                type='button'
                onClick={() => gotoPage(pageCount - 1)}
              >
                Last
              </button>
              <i
                className={`ti-control-forward ${
                  !canNextPage ? "btn-control-disabled" : ""
                }`}
                onClick={() => nextPage()}
              />
            </div>
          </div>
        </div>
      </div>
      )};

export default PaginationForTableComponent;
